import axios from "axios";
export default {
  On: async (IP, port, id) => {
    // console.log(`http://${IP}:${port}/On ID: ${id}`);
    let response = await axios.post(`http://${IP}:${port}/onn`, { id });
    return response.data;
  },

  Off: async (IP, port, id) => {
    // console.log(`http://${IP}:${port}/Off ID: ${id}`);
    let response = await axios.post(`http://${IP}:${port}/off`, { id });
    return response.data;
  },
};
